"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CRM_API_ERROR: 'crm-api-error',
  CRM_DEBUG: 'crm-debug',
  CRM_ONBOARDING: 'crm-onboarding',
  INDEX_INTERACTION: 'index-interaction',
  INTERNAL_CRM_TRACKING: 'internal-crm-tracking',
  RECORD_INTERACTION: 'record-interaction',
  SETTINGS_INTERACTION: 'settings-interaction',
  BIZOPS_INTERACTION: 'bizops-interaction'
};
exports.default = _default;
module.exports = exports.default;